import Members from '@/views/members/members.vue'
import AddMember from '@/views/members/members-new.vue'
import EditMember from '@/views/members/members-show.vue'
import { MembersRouteNames } from '@/router/routes-names'

export const membersRoutes = [
    {
        path: '/members',
        name: MembersRouteNames.LIST,
        component: Members,
        props: true
    },
    {
        path: '/members/new',
        name: MembersRouteNames.NEW,
        component: AddMember
    },
    {
        path: '/members/show/:memberId',
        name: MembersRouteNames.SHOW,
        component: EditMember
    }
]
